import {
  Component,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-unit-info",
  templateUrl: "./unit-info.component.html",
  styleUrls: ["./unit-info.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UnitInfoComponent),
      multi: true,
    },
  ],
})
export class UnitInfoComponent
  implements ControlValueAccessor, OnInit, OnDestroy
{
  @Input() unitType: string | number;
  inputControl: FormControl = new FormControl(0);
  @Input() set currentValue(s) {
    this.inputControl.patchValue(s);
  }
  @Input() minValue?: number;
  @Input() maxValue?: number;
  @Output() currentValueChange: Subject<number> = new Subject<number>();
  @Input() isDisabled: boolean = false;
  @Input() originalValue?: number;

  destroy$ = new Subject();

  constructor() {}

  ngOnInit(): void {
    if (this.isDisabled) this.inputControl.disable();
    this.inputControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((v) => {
        if (v == undefined) {
          this.inputControl.patchValue(0);
          return;
        }
        if (v != Math.round(v)) {
          this.inputControl.patchValue(Math.round(v));
          return;
        }
        if (!isNaN(this.maxValue) && v > this.maxValue) {
          this.inputControl.patchValue(this.maxValue);
          return;
        }
        if (!isNaN(this.minValue) && v < this.minValue) {
          this.inputControl.patchValue(this.minValue);
          return;
        }
        this.currentValueChange.next(v);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
  incrementControl() {
    if (this.isDisabled) return;

    if (this.maxValue != null && this.inputControl.value + 1 > this.maxValue)
      return;

    this.inputControl.patchValue(this.inputControl.value + 1);
  }

  decrementControl() {
    if (this.isDisabled) return;

    if (this.minValue != null && this.inputControl.value - 1 < this.minValue)
      return;

    this.inputControl.patchValue(this.inputControl.value - 1);
  }

  writeValue(obj: any): void {
    this.currentValue = obj || 0;
  }
  registerOnChange(fn: any): void {
    this.currentValueChange.pipe(takeUntil(this.destroy$)).subscribe(fn);
  }
  registerOnTouched(fn: any): void {
    this.onTouched();
  }
  onTouched = () => null;

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    if (this.inputControl.disabled && !isDisabled) this.inputControl.enable();
    else if (!this.inputControl.disabled && isDisabled)
      this.inputControl.disable();
  }
}
